import { RECENT_SEARCH_VIEWED_LIST } from "../actions/recentSearch.action";

const INITIAL_STATE = {
   list: [],
   loading: true,
   limit: 5,
   offset: 0,
   totalCount: 0,
};

export default function recentSearchList(state = INITIAL_STATE, action) {
   switch (action.type) {
      case RECENT_SEARCH_VIEWED_LIST:
         return {
            ...state,
            list: action.payload.list,
            loading: action.payload.loading,
         };
      default:
         return state;
   }
}
